// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2CXK5","colMaxWidth":"Table_colMaxWidth__rKMN2"};